import type { TweetListResponsePageAllOfThreeContentItemEngagementAllOf } from './tweetListResponsePageAllOfThreeContentItemEngagementAllOf';
import type { TweetListResponsePageAllOfThreeContentItemEngagementAllOfTwo } from './tweetListResponsePageAllOfThreeContentItemEngagementAllOfTwo';

export type TweetListResponsePageAllOfThreeContentItemEngagement = TweetListResponsePageAllOfThreeContentItemEngagementAllOf & TweetListResponsePageAllOfThreeContentItemEngagementAllOfTwo;
